import { render } from "./InvoiceInput.vue?vue&type=template&id=573f7a61"
import script from "./InvoiceInput.vue?vue&type=script&lang=js"
export * from "./InvoiceInput.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__